var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3, _path8, _path9, _g4, _path10, _path11, _g5, _path12, _path13, _path14, _path15, _g6, _g7, _g8, _g9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint0_radial_7000_4954)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint1_radial_7000_4954)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint2_radial_7000_4954)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint3_radial_7000_4954)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint4_linear_7000_4954)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5839 28.6607C16.1161 28.9641 16.7617 28.9468 17.2919 28.6398C20.4206 26.8279 25.727 22.7671 27.8261 17.5109C30.944 10.5851 23.6232 5.0566 18.5635 9.03293C18.0595 9.42903 17.4316 9.87979 16.9783 10.3112C16.7367 10.5412 16.3145 10.5648 16.0657 10.3426C15.4643 9.80564 14.5706 9.13969 13.9893 8.7464C9.67581 5.82806 1.82734 9.67493 5.17522 17.8851C6.38862 21.5312 12.1224 26.6879 15.5839 28.6607Z",
    fill: "url(#paint5_linear_7000_4954)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2839 10.5583C17.1644 11.3788 18.5403 11.1321 19.3164 10.2122C20.2982 9.04842 21.6489 7.91684 23.4033 7.80521C21.8163 7.5 20.0874 7.83542 18.5636 9.03297C18.4326 9.13591 18.2932 9.24255 18.1507 9.35157C17.7293 9.67405 17.2805 10.0175 16.94 10.3482C16.7197 10.5621 16.3333 10.584 16.1054 10.3782C16.0713 10.3474 16.0361 10.3161 16 10.2844C16.0791 10.3647 16.176 10.4577 16.2839 10.5583Z",
    fill: "url(#paint6_linear_7000_4954)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9828 13.7877V17.9615C16.9828 20.6761 19.8286 21.5419 20.5238 18.9178C20.9566 17.2837 21.0749 15.5926 20.6068 14.0859C20.26 12.9698 19.4639 12.3168 18.6731 12.036C17.66 11.6762 16.9828 12.7126 16.9828 13.7877Z",
    fill: "#FA1C56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.0632,
    cy: 13.0939,
    rx: 3.61593,
    ry: 2.48802,
    transform: "rotate(-44.1901 24.0632 13.0939)",
    fill: "url(#paint7_radial_7000_4954)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.718,
    cy: 13.5405,
    rx: 4.61173,
    ry: 2.48802,
    transform: "rotate(-128.955 13.718 13.5405)",
    fill: "url(#paint8_radial_7000_4954)",
    fillOpacity: 0.6
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17055 6.55145C6.45096 6.89173 5.9748 7.37521 5.66436 7.7562C5.45504 8.01309 5.0771 8.05166 4.82021 7.84234C4.56332 7.63302 4.52476 7.25509 4.73408 6.9982C5.11114 6.53544 5.72091 5.90955 6.65757 5.46662C7.60054 5.02071 8.83602 4.77871 10.4319 5.02649C10.7593 5.07733 10.9836 5.38399 10.9327 5.71144C10.8819 6.03889 10.5752 6.26312 10.2478 6.21228C8.87491 5.99913 7.88383 6.21416 7.17055 6.55145Z",
    fill: "url(#paint9_radial_7000_4954)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17055 6.55145C6.45096 6.89173 5.9748 7.37521 5.66436 7.7562C5.45504 8.01309 5.0771 8.05166 4.82021 7.84234C4.56332 7.63302 4.52476 7.25509 4.73408 6.9982C5.11114 6.53544 5.72091 5.90955 6.65757 5.46662C7.60054 5.02071 8.83602 4.77871 10.4319 5.02649C10.7593 5.07733 10.9836 5.38399 10.9327 5.71144C10.8819 6.03889 10.5752 6.26312 10.2478 6.21228C8.87491 5.99913 7.88383 6.21416 7.17055 6.55145Z",
    fill: "url(#paint10_linear_7000_4954)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.1423 7.20535C5.43918 6.81993 7.1423 4.93191 10.2361 5.46316",
    stroke: "url(#paint11_linear_7000_4954)",
    strokeOpacity: 0.5,
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4518 4.03018C6.24374 3.08861 3.73092 6.04965 3.09404 6.83127C2.88473 7.08816 2.50679 7.12673 2.2499 6.91741C1.99301 6.70809 1.95444 6.33016 2.16376 6.07327C2.90189 5.16739 5.81094 1.79091 11.6653 2.84933C11.9914 2.90828 12.208 3.22041 12.149 3.5465C12.0901 3.87258 11.7779 4.08914 11.4518 4.03018Z",
    fill: "url(#paint12_linear_7000_4954)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4518 4.03018C6.24374 3.08861 3.73092 6.04965 3.09404 6.83127C2.88473 7.08816 2.50679 7.12673 2.2499 6.91741C1.99301 6.70809 1.95444 6.33016 2.16376 6.07327C2.90189 5.16739 5.81094 1.79091 11.6653 2.84933C11.9914 2.90828 12.208 3.22041 12.149 3.5465C12.0901 3.87258 11.7779 4.08914 11.4518 4.03018Z",
    fill: "url(#paint13_linear_7000_4954)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.56418 6.37722C2.86105 5.9918 5.28293 2.81472 10.5017 3.09597",
    stroke: "url(#paint14_linear_7000_4954)",
    strokeOpacity: 0.6,
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8294 6.55145C25.549 6.89173 26.0252 7.37521 26.3356 7.7562C26.545 8.01309 26.9229 8.05166 27.1798 7.84234C27.4367 7.63302 27.4752 7.25509 27.2659 6.9982C26.8889 6.53544 26.2791 5.90955 25.3424 5.46662C24.3995 5.02071 23.164 4.77871 21.5681 5.02649C21.2407 5.07733 21.0164 5.38399 21.0673 5.71144C21.1181 6.03889 21.4248 6.26312 21.7522 6.21228C23.1251 5.99913 24.1162 6.21416 24.8294 6.55145Z",
    fill: "url(#paint15_linear_7000_4954)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8294 6.55145C25.549 6.89173 26.0252 7.37521 26.3356 7.7562C26.545 8.01309 26.9229 8.05166 27.1798 7.84234C27.4367 7.63302 27.4752 7.25509 27.2659 6.9982C26.8889 6.53544 26.2791 5.90955 25.3424 5.46662C24.3995 5.02071 23.164 4.77871 21.5681 5.02649C21.2407 5.07733 21.0164 5.38399 21.0673 5.71144C21.1181 6.03889 21.4248 6.26312 21.7522 6.21228C23.1251 5.99913 24.1162 6.21416 24.8294 6.55145Z",
    fill: "url(#paint16_linear_7000_4954)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5482 4.03018C25.7563 3.08861 28.2691 6.04965 28.906 6.83127C29.1153 7.08816 29.4932 7.12673 29.7501 6.91741C30.007 6.70809 30.0456 6.33016 29.8362 6.07327C29.0981 5.16739 26.1891 1.79091 20.3347 2.84933C20.0086 2.90828 19.792 3.22041 19.851 3.5465C19.9099 3.87258 20.2221 4.08914 20.5482 4.03018Z",
    fill: "url(#paint17_linear_7000_4954)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5482 4.03018C25.7563 3.08861 28.2691 6.04965 28.906 6.83127C29.1153 7.08816 29.4932 7.12673 29.7501 6.91741C30.007 6.70809 30.0456 6.33016 29.8362 6.07327C29.0981 5.16739 26.1891 1.79091 20.3347 2.84933C20.0086 2.90828 19.792 3.22041 19.851 3.5465C19.9099 3.87258 20.2221 4.08914 20.5482 4.03018Z",
    fill: "url(#paint18_linear_7000_4954)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4704 3.28353C22.1892 3.00228 26.3767 2.7054 29.0954 5.87728",
    stroke: "url(#paint19_linear_7000_4954)",
    strokeOpacity: 0.75,
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6675 5.53325C23.3862 5.252 25.0486 5.33032 26.9079 7.25219",
    stroke: "url(#paint20_linear_7000_4954)",
    strokeOpacity: 0.75,
    strokeWidth: 0.3,
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20.3611,
    cy: 3.33034,
    r: 0.161886,
    fill: "#FF93BA"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_7000_4954)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.6675,
    cy: 5.53152,
    r: 0.161886,
    fill: "#FF93BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7000_4954",
    x: 14.9828,
    y: 9.96326,
    width: 7.92457,
    height: 12.5358,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_7000_4954",
    x: 19.4436,
    y: 8.50562,
    width: 9.23921,
    height: 9.17639,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_7000_4954",
    x: 8.73192,
    y: 8.12695,
    width: 9.97219,
    height: 10.8271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_7000_4954",
    x: 4.74229,
    y: 4.96948,
    width: 5.89378,
    height: 2.63586,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_7000_4954",
    x: 2.16417,
    y: 2.67834,
    width: 8.73751,
    height: 4.09888,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_7000_4954",
    x: 20.0704,
    y: 2.71997,
    width: 9.42503,
    height: 3.55725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_7000_4954",
    x: 21.2675,
    y: 5.01282,
    width: 6.04047,
    height: 2.6394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.125,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_7000_4954",
    x: 19.6992,
    y: 2.66846,
    width: 1.32378,
    height: 1.32373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_7000_4954",
    x: 21.0056,
    y: 4.86963,
    width: 1.32378,
    height: 1.32373,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_7000_4954"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.9262 28.5301) rotate(-90) scale(28.302 48.1134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596003,
    stopColor: "#FF3B79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4EC6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4772 13.2266) rotate(142.986) scale(22.7831 42.6749)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.483055,
    stopColor: "#B91D43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833898,
    stopColor: "#B91D43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8466 18.8085) rotate(-158.663) scale(19.7624 27.9369)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40984,
    stopColor: "#B91D43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833898,
    stopColor: "#B91D43"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9925 15.3571) rotate(90) scale(17.1998 17.1998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.671096,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7000_4954",
    x1: 17.8908,
    y1: 17.3704,
    x2: 24.8512,
    y2: 25.6539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7000_4954",
    x1: 17.0279,
    y1: 17.7156,
    x2: 8.85945,
    y2: 26.9195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.694491,
    stopColor: "#FF7AF2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.933555,
    stopColor: "#FFBCE6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7000_4954",
    x1: 19.6978,
    y1: 11.4742,
    x2: 17.257,
    y2: 8.7925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40984,
    stopColor: "#C12372",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833898,
    stopColor: "#B5286E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.7023 13.8589) rotate(-176.775) scale(5.34737 3.61079)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73A6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4404 14.2125) rotate(-178.667) scale(9.81495 5.19821)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF73A6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_7000_4954",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.50168 7.28345) rotate(-112.35) scale(2.54758 9.11482)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F12E52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF3B79"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7000_4954",
    x1: 12.0954,
    y1: 6.45223,
    x2: 8.09543,
    y2: 7.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE2654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7000_4954",
    x1: 9.66574,
    y1: 5.54129,
    x2: 6.50949,
    y2: 7.20535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7000_4954",
    x1: 3.75168,
    y1: 7.05229,
    x2: 8.96386,
    y2: 4.05926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FF1A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7000_4954",
    x1: 14.0047,
    y1: 4.8492,
    x2: 7.64071,
    y2: 5.81682,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE2654"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578125,
    stopColor: "#CE2654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7000_4954",
    x1: 9.0173,
    y1: 3.51784,
    x2: 4.043,
    y2: 6.08035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7000_4954",
    x1: 26.3224,
    y1: 7.97722,
    x2: 22.9054,
    y2: 6.20286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FF1A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7000_4954",
    x1: 27.0954,
    y1: 9.15845,
    x2: 25.1958,
    y2: 6.99322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108014,
    stopColor: "#9C1036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE2654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7000_4954",
    x1: 28.2483,
    y1: 7.05229,
    x2: 23.0361,
    y2: 4.05926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.046875,
    stopColor: "#FF1A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4781"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7000_4954",
    x1: 29.2829,
    y1: 8.81476,
    x2: 26.7828,
    y2: 5.37175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.108014,
    stopColor: "#9C1036"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CE2654",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7000_4954",
    x1: 27.9492,
    y1: 3.42638,
    x2: 22.9883,
    y2: 6.43073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7000_4954",
    x1: 29.1463,
    y1: 5.6761,
    x2: 24.1853,
    y2: 8.68045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF93BA",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF93BA",
    stopOpacity: 0.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.cf24a9f38a1a669c71f8ba248a6be6b9.svg";
export { ForwardRef as ReactComponent };